import React, { useState,useContext } from "react";
import styled from "styled-components";
import { SalleContext } from "../../context/salle";
import CardDataAddressTiny from "../CardDataAddressTiny";
import CardDataModalTiny from "../CardDataModalTiny";

const CardWrapper = styled.div`
    transition: all .2s;
    position: fixed;
    top:0;
    right: ${(props) => (props.active ? " 0" : "-9999px")};
    width: 630px;
    height: 100vh;
    background-color: white;
    box-shadow: 0 0 5px #312f2f71;
    border-radius: 10px;
    padding-left: 20px;
    padding-right: 20px;

    button{
        margin-top:1.2rem;
    }

`
const HeaderCard = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height:90px;


    p{
        height: 0px;
        font-size: 1.1rem;
        font-family: "Poppins";
        font-weight: 600;
    }
    
    button{
        margin-top: 1.0rem;
        font-family: "Poppins";
        font-weight: 600;
        border: none;
        background-color: white;
    }

    button > svg{
        margin-left: 0.3rem;
    }


`
const Line = styled.div`
    display: flex;
    align-items: center;
    margin-bottom:0.5rem;
    p{
        font-size: 1.0rem;
        font-family: "Poppins";
        font-weight: 700;
        cursor: pointer;
        margin-right: 0.9rem;
    }

    .check{
        transition: all .2s;
        color:#353535;
    }

    .check::after{
        display: block;
        content: "";
        border-bottom: 1px solid black;
    }



`

const HorizontalModal = () => {
    const {setModalSalle,modalSalle,products} = useContext(SalleContext)
    const [option, setOption] = useState(1)

    return (

        <CardWrapper  active={modalSalle} >

            <HeaderCard>
                <p>{products[0]?.name_product}</p>
                <button onClick={() => setModalSalle(false)}>Fechar
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.0290527" y="0.0620117" width="24" height="24" rx="12" fill="#373839" />
                        <path d="M12.792 11.942L15.6111 14.761C15.6869 14.8368 15.6869 14.9202 15.6111 15.0111L15.0882 15.534C14.9972 15.6098 14.9139 15.6098 14.8381 15.534L14.3607 15.0338L12.019 12.7149L9.19998 15.534C9.1242 15.6098 9.04084 15.6098 8.9499 15.534L8.42701 15.0111C8.35123 14.9202 8.35123 14.8368 8.42701 14.761L11.2461 11.942L8.42701 9.12289C8.35123 9.04711 8.35123 8.96375 8.42701 8.87281L8.9499 8.34992C9.04084 8.27414 9.1242 8.27414 9.19998 8.34992L12.019 11.169L14.8381 8.34992C14.9139 8.27414 14.9972 8.27414 15.0882 8.34992L15.6111 8.87281C15.6869 8.96375 15.6869 9.04711 15.6111 9.12289L15.1109 9.60031L12.792 11.942Z" fill="#FAFAFA" />
                    </svg>
                </button>
            </HeaderCard>

            <Line>
                <p onClick={() => setOption(1)} className={option == 1 ? 'check' : ''}>dados do item</p>
                {/* <p onClick={() => setOption(2)} className={option == 2 ? 'check' : ''}>comissões</p>
                <p onClick={() => setOption(3)} className={option == 3 ? 'check' : ''}>impostos</p> */}
            </Line>

            <CardDataModalTiny/>
            <button type="button" class="btn btn-outline-dark" onClick={() => setModalSalle(false)}>Fechar janela</button>

            

        </CardWrapper>
    )
}

export default HorizontalModal